import {useEffect, useMemo } from "react";
import {BridgeToken} from "../bridge";
import Context, {ContextType} from "./Context";


export interface BridgedContextProps {
    children?: React.ReactNode;
}
function BridgedContext(props: BridgedContextProps): React.ReactElement {
    const {
        children
    } = props;
    const searchParams = new URLSearchParams(window.location.search);
    const bridgedToken = searchParams.get("bridged");
    const _bridge = useMemo(() => {
        try {
            if (bridgedToken) {
                return BridgeToken.valueOf(bridgedToken)
            }
        } catch (e) {
            console.warn("bridge exception", e);
        }
        return undefined;
    }, [bridgedToken]);
    useEffect(() => {
        if (_bridge) {
            sessionStorage.setItem("bridged", JSON.stringify(_bridge));
        }
    }, [_bridge]);
    const bridge = useMemo<BridgeToken | undefined>(() => {
        if (_bridge) {
            return _bridge;
        }
        const bridged = sessionStorage.getItem("bridged");
        if (bridged) {
            try {
                return JSON.parse(bridged);
            } catch (e) {
                console.warn("bridge parse storage exception", e);
            }
        }
        return undefined;
    }, [_bridge])
    const contextValue = useMemo<ContextType>(() => {
        return {
            bridge: bridge,
        }
    }, [bridge]);
    return <Context.Provider value={contextValue}>
        {children}
    </Context.Provider>
}


export default BridgedContext;